export default "__VITE_ASSET__7e265220__"